import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServerErrorModalService } from '@app/utils/services/server-error-modal.service';

@Component({
  selector: 'app-server-error-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './server-error-modal.component.html',
  styleUrl: './server-error-modal.component.scss',
})
export class ServerErrorModalComponent {
  protected readonly modalService = inject(ServerErrorModalService);
  // Scope obligatorio para data-testid; el padre lo provee según su contexto.
  @Input({ required: true }) testIdScope!: string;

  protected tid(suffix: string): string {
    return `${this.testIdScope}-dialog-servererror-${suffix}`;
  }

  onClose(): void {
    this.modalService.hide();
  }

  onButtonClick(): void {
    this.modalService.hide();
  }

  onOverlayClick(): void {
    this.onClose();
  }

  onModalClick(event: Event): void {
    event.stopPropagation();
  }
}
